import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

export const ipynb = (
  state: string | null = null,
  action: NotebookAction
): string | null => {
  switch (action.type) {
    case NotebookActionKey.SET_DRAFT_SPEC:
      // TODO(cochamberlain): Map usage over to generic entities.
      return action.payload.draftSpec.source.serialize();
    case NotebookActionKey.SET_IPYNB:
      return action.payload.ipynb;
    default:
      return state;
  }
};
